import ProductionStandarTime from '@/models/ProductionStandarTime/ProductionStandarTime';

export default class ProductionStandarTimeFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.standarTimeName = '';
		this.standarTimeCategoryId  = '';
		this.standarTimeCategoryCode = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			standarTimeName : '0',
			standarTimeCategoryId : '0',
			standarTimeCategoryCode : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}